'use strict';

var index = require('./variants/index.js');
var locales = require('./core/locales.js');
var moneyFormat = require('./core/moneyFormat.js');



exports.variants = index.default;
Object.defineProperty(exports, "locales", {
	enumerable: true,
	get: function () { return locales.locales; }
});
exports.moneyFormat = moneyFormat.moneyFormat;
//# sourceMappingURL=index.js.map
